import {  VisibilityRounded, VisibilityOffRounded, Send, Check, Delete, Clear } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Card, CardContent, Chip, Collapse, GridLegacy as Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType,  FormActions, FormatPrice,  usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalComprarCotizaciones, ModalFormGenerador } from "../../../components/form/ModalForm";

import { FilterForm } from "../../../components/form/filter-form";
import { CustomDialog } from "../../../components/modals/custom-dialog";



const schemaFilter = yup.object({
  

}).required();


const validationCaso = yup.object({
  descripcion: yup.string().required(),

  }).required();


const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:"",
  proveedor:null,
  order_id:null,
  comprador:null
};


const ComparativoSegment = ({listado})=>{
  
return (
  <Stack direction={"row"} >
    {
      listado.map( item=>
<Card 
key={item.cod_cotizacion}
style={{background: item.ind_seleccion === "SI"?'#1B7A4A':"white",color: item.ind_seleccion === "SI"?'white':"black"}} >
        <CardContent>
          <Typography variant="body1" >$ {FormatPrice(item.valor_kg,1)} X KG</Typography>
          <Typography variant="caption" fontSize={'10px'} >{item.proveedor}</Typography>
        </CardContent>
      </Card>

       )
    }
      
  </Stack>
)

}


const SubtableItemsCesta = ({
  items,
  onResetearCesta
})=>{


  const columnsTable = [
    {
    
      key:"nombre_producto",
      keyValue:"nombre_producto",
      label:"Producto",
      headerRender:(props)=>props.label,
      bodyRender:(props)=>props.value,
      typeRow:"string",
      sort:false,
      sortFunction:()=>{},
      sortStatus:"", 
 
     },
    {
    
      key:"total_un_empaques",
      keyValue:"total_un_empaques",
      label:"Cantidad (UM)",
      headerRender:(props)=>props.label,
      bodyRender:({info})=>`${Number(info.total_un_empaques || 0).toFixed(2)} ${info.nombre_unidad_medida}`,
      typeRow:"string",
      sort:false,
      sortFunction:()=>{},
      sortStatus:"", 
 
     },
  
     {
    
      key:"precio_unidad_medida",
      keyValue:"precio_unidad_medida",
      label:"Valor (UM)",
      headerRender:(props)=>props.label,
      bodyRender:({info,value})=>`$ ${FormatPrice(value,1)}`,
      typeRow:"string",
      sort:false,
      sortFunction:()=>{},
      sortStatus:"", 
 
     },
     {
    
      key:"valor_kg",
      keyValue:"valor_kg",
      label:"Valor (KG)",
      headerRender:(props)=>props.label,
      bodyRender:({info,value})=>`$ ${FormatPrice(value,1)}`,
      typeRow:"string",
      sort:false,
      sortFunction:()=>{},
      sortStatus:"", 
 
     },
 {
    
      key:"cotizaciones_list",
      keyValue:"cotizaciones_list",
      label:"Comparativo",
      headerRender:(props)=>props.label,
      bodyRender:({info,value})=><ComparativoSegment listado={value} />,
      typeRow:"string",
      sort:false,
      sortFunction:()=>{},
      sortStatus:"", 
 
     }
  
  ]

  return (
    <Grid container >
  
      <Grid item xs={12} sm={12} md={12} >
      
        <Table>
            <TableHead>
              <TableRow>
               
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>
          </TableHead>
          <TableBody>
              
                 {items.map( prod=>
                  [
                    <TableRow key={prod.cod}  >
                     
                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.key}  >
                          {<Col.bodyRender key={prod.key} value={prod[Col.keyValue]} info={prod} />}
                       </TableCell>)
                    }

                  </TableRow>,
              ]
                )}
              
            </TableBody>
        </Table>

      </Grid>
    </Grid>
  )

}


const defaultCasoData = {
  descripcion:"",
  ind_tipo_alerta:"COMPRA",
  ind_estado:"ABIERTO",
  id_entidad:null
};



export const ComprasPorComprador = ({
  fechaSeleccionada
})=>{

  const [compradores,setCompradores] = useState([]);
  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [dataEntity,setDataEntity] = useState({...defaultCasoData});
  const [isVisibleCasoModal,setIsVisibleCasoModal] = useState(false);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
      let {data:{value:compradores}} = await AxiosInstance.get("maestros/listar-compradores");
      setCompradores([...compradores]);
   
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }

    const loadItems =  async (loading=true)=>{

      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

    
     let {data:{value}} = await AxiosInstance.post("auditoria/listar-compras",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number + 1,
      comprador:filterSearchPagination.comprador || null,
      order_id:filterSearchPagination.order_id || null
     });
   
     setDataSetProductos(value?.data || []);
     setTotalRows(value?.total || 0);
  
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
    };

    const abrirModalCaso = (orden_compra_id)=>{
      setIsVisibleCasoModal(true);
      setDataEntity({...defaultCasoData,id_entidad:orden_compra_id});
    }






    const  setFilterAply = (filtros)=>{
      setFilterSearchPagination({
        ...filterSearchPagination,
        page_number:0,
        order_id:filtros.order_id || null,
        comprador:filtros.comprador?.value || null
      });
     
    }

    const getCestaColor = status=>{
      if (status === 'NO'){
        return "error";
      }
      if (status === 'SI'){
        return "success";
      }
      return "default";
    }
  
    const columnsTable = [
      {
      
        key:"cod",
        keyValue:"cod",
        label:"COD",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"usuario_comprador",
        keyValue:"usuario_comprador",
        label:"Comprador",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
       key:"proveedor",
       keyValue:"proveedor",
       label:"Proveedor",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"fecha_creacion",
        keyValue:"fecha_creacion",
        label:"Fecha de creacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_entrega",
        keyValue:"fecha_entrega",
        label:"Fecha de entrega",
        headerRender:(props)=>props.label,
        bodyRender: (props) =>dayjs( props.value).format(DateFormatString) ,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"ind_certificado",
        keyValue:"ind_certificado",
        label:"Certificado",
        headerRender:(props)=>props.label,
        bodyRender: (props) =><Chip label={props.value || 'EN REVISION'} color={getCestaColor(props.value)}  />  ,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
        
        key:"detalle_orden",
        keyValue:"detalle_orden",
        label:"Total items",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value.length,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       
       {
        key:"Action_list",
        keyValue:"cod",
        label:"Certificar",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Stack
        direction="column"
        >
        <Stack direction={"row"} spacing={1} >
          <Button disabled={ ['SI','NO'].includes(info.ind_certificado) }  onClick={e=>abrirModalCaso(value)} variant="contained" size="small" color="error" ><Clear /></Button>
          <Button disabled={info.ind_certificado === 'SI'} onClick={e=>onSaveCertification(value)} variant="contained" size="small" color="success" ><Check /></Button>
        </Stack>
        </Stack>,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },  
    ];
   
    const InputFilters = [

      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"comprador",
        InputComponentProps:{
          label:"Comprador",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          //onInputChange: onSearchProveedor,
          options: compradores || [],
          noOptionsText: "Lista vacia",

        }
      },
      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:InputWithLabel,
        keyValue:"order_id",
        InputComponentProps:{
          label:"Orden ID",
          fullWidth: true,
          size:'small',
        }
      }
     
      ];

      const onOpenedDetal = (index)=>{
        let copyItems = [...dataSetProdctos];
        copyItems[index].openedDetail = copyItems[index].openedDetail?false:true;
        setDataSetProductos(copyItems);
      }

      const ResetearItemCesta = (cesta_id)=>{

        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });

        AxiosInstance.post("cotizaciones/resetear-cesta-preaprobada",{
          cesta_id
         })
         .then(({data})=>{
          

         }).catch(error=>{

          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });

         })
         .finally(()=>{
          loadItems();
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
         });


      }

 



      const onSaveCertification = (entityId)=>{

        onSaveCaso(null,{id_entidad:entityId},undefined,'certificar_compra');


           
      }

      const onSaveCaso = (typeaction,data={},form_actions,ac_type='abrir_caso')=>{
            const payload = {
              entidad_id:data.id_entidad,
              caso:data,
              type:ac_type
            }

            dispatch({
              type:ActionTypes.setLoadingPage,
              data:true
            });
    
            AxiosInstance.post("auditoria/actualizar-estatus-entidad-auditada",{
              ...payload
             })
             .then(({data})=>{
              setIsVisibleCasoModal(false);
              loadItems();
    
              if( data.status ){
                dispatch({
                  type:ActionTypes.setModalInfo,
                  data:{
                      title:data.msg,
                      message:data.msg,
                      type:DialogType.exitoso,
                      isVisible:true
                  }
                });
              }else{
    
                dispatch({
                  type:ActionTypes.setModalInfo,
                  data:{
                      title:"Error",
                      message:data.msg,
                      type:DialogType.peligro,
                      isVisible:true
                  }
                });
    
              }
              
    
             }).catch(error=>{
    
              dispatch({
                type:ActionTypes.setModalInfo,
                data:{
                    title:"Error",
                    message:"Error de comunicacion verifique su conexion a internet",
                    type:DialogType.peligro,
                    isVisible:true
                }
              });
    
              
    
             })
             .finally(()=>{
              dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
              });
             });
      }


      const configModalCaso = {
        titleModal: "Abrir caso",
        schemaValidator:validationCaso,
        typeAction:FormActions.AGREGAR,
        isVisible:isVisibleCasoModal,
        onSendForm:onSaveCaso,
        entityValues:{...dataEntity},
        buttomsAction: [
           
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              color:"secondary",
              onClick:()=>setIsVisibleCasoModal(false)
            }
          },
          {
            title:"Guardar",
            buttomProps:{
              type:"submit",
            //  onClick:onSaveModData
            }
          }
  
        ],
        imputs:[
          {
            key:"descripcion",
            keyValue:"descripcion",
            label:"Describa la situacion",
            responsiveSize:12,
            component:InputWithLabel,
            inputProps:{
              fullWidth:true,
              multiline:true,
              minRows:3,
              type:"text",
              size:"small"
            }
          },
        ],
        arrayInputs:[]
      } ;

      

    return (<>


    {
      isVisibleCasoModal &&
    <ModalFormGenerador 

    {
      ...configModalCaso
    }

    />
    }

   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

        <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar compras por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {
              comprador:null,
              order_id:InitialFilterSearch.order_id
             }
            }
            onApplyFilter={setFilterAply}
          />

        </Grid>
      
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
                <TableCell>

                </TableCell>
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( (prod,prod_index)=>
                  [
                    <TableRow key={prod.key_item}  >
                       <TableCell>
                        <IconButton onClick={e=>onOpenedDetal(prod_index)} >
                          {prod.openedDetail? <VisibilityOffRounded />: <VisibilityRounded />}
                         
                        </IconButton>
                       </TableCell>
                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.key}  >
                          {<Col.bodyRender key={prod.key} value={prod[Col.keyValue]} info={prod} />}
                       </TableCell>)
                    }

                  </TableRow>,
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={columnsTable.length + 1} >

                      <Collapse in={prod.openedDetail} unmountOnExit >
                        <SubtableItemsCesta onResetearCesta={ResetearItemCesta} items={prod.detalle_orden} />
                      </Collapse>

                    </TableCell>
                  </TableRow>
                  ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}